// extracted by mini-css-extract-plugin
export var card = "_r4-0";
export var content = "_r4-2";
export var details = "_r4-3";
export var icon = "_r4-1";
export var iconBlue = "_r4-5";
export var iconBrand = "_r4-4";
export var iconGrayBlue = "_r4-6";
export var iconGreen = "_r4-7";
export var iconIndigo = "_r4-8";
export var iconOrange = "_r4-9";
export var iconPurple = "_r4-a";
export var iconRed = "_r4-b";
export var iconWarning = "_r4-c";